import React, { Component } from 'react';
import './TableBasic.css';
class TableBasic extends Component {
  render() {
    return (
      <div style={{ display: 'none' }}>
        <svg>
          <defs>
            <symbol id="favorite-off" data-name="favorite-off" viewBox="0 0 17 16.12">
              <path
                className="table-basic-icon-10"
                d="M16,5.91,10.7,5.8,9,.82A.48.48,0,0,0,8,.82L6.3,5.8,1,5.91a.48.48,0,0,0-.28.86L4.93,10,3.39,15a.48.48,0,0,0,.73.54l4.38-3,4.38,3a.48.48,0,0,0,.73-.54l-1.54-5,4.24-3.18A.48.48,0,0,0,16,5.91Z"
              />
            </symbol>
            <symbol id="remove-s-off" data-name="remove-s-off" viewBox="0 0 12.71 12.71">
              <line className="table-basic-icon-10" x1="12.35" y1="0.35" x2="0.35" y2="12.35" />
              <line className="table-basic-icon-10" x1="0.35" y1="0.35" x2="12.35" y2="12.35" />
            </symbol>
            <symbol id="remove-s-hover" data-name="remove-s-hover" viewBox="0 0 12.71 12.71">
              <line className="table-basic-icon-11" x1="12.35" y1="0.35" x2="0.35" y2="12.35" />
              <line className="table-basic-icon-11" x1="0.35" y1="0.35" x2="12.35" y2="12.35" />
            </symbol>
            <symbol id="favorite-on" data-name="favorite-on" viewBox="0 0 16 15.12">
              <path
                className="table-basic-icon-8"
                d="M15.53,5.41,10.2,5.3,8.45.32a.48.48,0,0,0-.91,0L5.8,5.3.47,5.41a.48.48,0,0,0-.28.86L4.43,9.45l-1.54,5a.48.48,0,0,0,.73.54L8,12l4.38,3a.48.48,0,0,0,.73-.54l-1.54-5,4.24-3.18A.48.48,0,0,0,15.53,5.41Z"
              />
            </symbol>
            <symbol id="add_search_on" data-name="add search on" viewBox="0 0 11.66 11.66">
              <path
                className="table-basic-icon-2"
                d="M11.52,10.4,8.69,7.57A4.83,4.83,0,1,0,7.57,8.69l2.83,2.83a.71.71,0,0,0,1-.14A.71.71,0,0,0,11.52,10.4ZM1,4.8a3.8,3.8,0,1,1,3.8,3.8A3.8,3.8,0,0,1,1,4.8Z"
              />
              <path className="table-basic-icon-2" d="M2.46,5.34V4.27H7.3V5.34Z" />
            </symbol>
            <symbol id="add_search_off" data-name="add search off" viewBox="0 0 11.66 11.66">
              <path
                className="table-basic-icon-1"
                d="M11.52,10.4,8.69,7.57A4.83,4.83,0,1,0,7.57,8.69l2.83,2.83a.71.71,0,0,0,1-.14A.71.71,0,0,0,11.52,10.4ZM1,4.8a3.8,3.8,0,1,1,3.8,3.8A3.8,3.8,0,0,1,1,4.8Z"
              />
              <path
                className="table-basic-icon-1"
                d="M4.34,5.34H2.46V4.27H4.34V2.37H5.41v1.9H7.3V5.34H5.41V7.22H4.34Z"
              />
            </symbol>
            <symbol id="favorite-mark" data-name="favorite-mark" viewBox="0 0 16 16">
              <circle className="table-basic-icon-8" cx="8" cy="8" r="8" />
              <path
                className="table-basic-icon-9"
                d="M13.18,6.52,9.51,6.45,8.31,3a.33.33,0,0,0-.62,0L6.49,6.45l-3.66.07a.33.33,0,0,0-.19.59L5.55,9.3,4.49,12.77a.33.33,0,0,0,.5.37l3-2.07,3,2.07a.33.33,0,0,0,.5-.37L10.45,9.3l2.92-2.19A.33.33,0,0,0,13.18,6.52Z"
              />
            </symbol>
            <symbol id="check_box_-_off" data-name="check box - off" viewBox="0 0 11 11">
              <rect className="table-basic-icon-3" x="0.5" y="0.5" width="10" height="10" rx="1" ry="1" />
              <rect className="table-basic-icon-4" x="0.5" y="0.5" width="10" height="10" rx="1" ry="1" />
            </symbol>
            <symbol id="check_box_-_on" data-name="check box - on" viewBox="0 0 11 11">
              <rect className="table-basic-icon-5" x="0.5" y="0.5" width="10" height="10" rx="1" ry="1" />
              <rect className="table-basic-icon-6" x="0.5" y="0.5" width="10" height="10" rx="1" ry="1" />
              <path
                className="table-basic-icon-7"
                d="M4.32,7.61a.17.17,0,0,0,.25,0l3.86-4a.17.17,0,1,0-.25-.24L4.44,7.24,2.77,5.52a.17.17,0,1,0-.25.24Z"
              />
            </symbol>

            <symbol id="order_by" viewBox="-15.1 -15.4 30.3 30.8">
              <line className="table-basic-icon-13" x1="7.7" y1="3.1" x2="7.7" y2="-15.4" />
              <polygon className="table-basic-icon-1" points="0.3,-2.6 7.7,0.6 15.1,-2.6 7.7,15" />
              <line className="table-basic-icon-13" x1="-7.7" y1="-3.4" x2="-7.7" y2="15.4" />
              <polygon className="table-basic-icon-1" points="-0.3,2.2 -7.7,-1 -15.1,2.2 -7.7,-15.4" />
            </symbol>
            <svg width="1.2em" height="1.2em">
              <symbol id="order_by_asc" viewBox="-12 -14 7.4 28">
                <line className="table-basic-icon-13" x1="-7.7" y1="-3.4" x2="-7.7" y2="15.4" />
                <polygon className="table-basic-icon-1" points="-0.3,2.2 -7.7,-1 -15.1,2.2 -7.7,-15.4" />
              </symbol>
            </svg>
            <symbol id="order_by_desc" viewBox="4 -13.6 7.4 27.2">
              <line className="table-basic-icon-13" x1="7.7" y1="3.1" x2="7.7" y2="-15.4" />
              <polygon className="table-basic-icon-1" points="0.3,-2.6 7.7,0.6 15.1,-2.6 7.7,15" />
            </symbol>
          </defs>
        </svg>
      </div>
    );
  }
}

export default TableBasic;
